import React from 'react';

const Unauthorised = () => <div>Sorry, you are not authorised to view that page.</div>;

Unauthorised.displayName = 'Unauthorised';

export default Unauthorised;
